export default (file = {}) => {
  const extension = file.map((data) => data?.name?.split(".").slice(-1).pop())
  return extension.every((el) =>
    ["jpeg", "png", "pdf", "eml", "jpg", "msg"].includes(el.toLowerCase())
  )
}
